<template>
    <Dispatch_date-component>
        <div class="p-2">
            <b-row>
                <b-col md="3">
                    <b-form-group label="Selected Date:"  :label-cols="5" >
                        <v-date-picker mode='single' input-class="dateInput"
                        :available-dates='{ start: null, end: new Date() }'
                        v-model='selectDate'>
                        </v-date-picker>
                    </b-form-group>
                </b-col>

                <b-col md="4">
                    <b-form-group  label="Select Vehicle NO." :label-cols="5" class="mb-4">
                        <v-select v-model="selected_vehicleno" @input="selectsearchvehicle(selected_vehicleno)" :options="vehicleitems" placeholder="-- Select Vehicle NO --"></v-select>
                    </b-form-group>
                </b-col>

                <b-col md="5">
                    <div id='container'>
                        <b-form-group label="Warehouse ID" :label-cols="3">
                            <div id='container'>
                                <ejs-multiselect  id='multi_select2'  placeholder="Select WareHouse" v-model="valueWH" :dataSource='optionsWH' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                                ></ejs-multiselect>
                            </div>
                        </b-form-group>
                    </div>
                    <!-- <b-form-group  label="Select WH/Hub" :label-cols="4" class="mb-4">
                        <v-select v-model="selected_Hub" @input="selectsearchhub(selected_Hub)" :options="hubListing"
                            placeholder="-- Select Hub --"></v-select>
                    </b-form-group> -->
                </b-col>

                <b-col md="8"></b-col>

                <b-col md="4">
                    <b-button variant="primary" @click="DeliveryDateList()"> Search </b-button>&nbsp;
                    <b-button variant="danger" @click="clear()"> Clear </b-button>&nbsp;
                    <a :href="loadurl" target="_blank" v-if="totalRows>0">
                        <b-button variant="primary" @click="downlaodloadurl">Download
                        </b-button>
                    </a>
                    <!-- <b-button variant="primary" > Download </b-button>&nbsp; -->
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12" class="text-right">
                    <p > <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
                 </b-col>
            </b-row>

            <div>
                <b-table
                show-empty responsive :fields="fields" :items="items" :filter="filter" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :bordered="bordered"
                  class="Delivery_Dashboard"
                >
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                <template slot="thead-top" slot-scope="data">
                    <tr class="bordercalls">
                        <th></th>
                        <th></th>
                        <th colspan="2" class="totalload">Total Delivered Loads</th>
                        <th></th>
                    </tr>
                  </template>
                  <template slot="cms" slot-scope="row">
                    <span v-if="row.item.cms==null">0</span>
                    <button v-b-tooltip.hover title="View Details" @click="shipmentStatusmodal('CMS',row.item)" style="background-color:white !important;
                    margin-top: -8px;
                " class="btn btn-link" v-else >
                        <span style="color:#1b8eb7">{{row.item.cms}}</span>
                    </button>
                </template>

                <template slot="app" slot-scope="row">
                    <span v-if="row.item.app==null">0</span>
                    <button v-b-tooltip.hover title="View Details" @click="shipmentStatusmodal('Application',row.item)" style="background-color:white !important;
                    margin-top: -8px;
                " class="btn btn-link"  v-else>
                        <span style="color:#1b8eb7">{{row.item.app}}</span>
                    </button>
                </template>

                <template slot="hubinscan" slot-scope="row">
                    <span v-if="row.item.hubinscan==null">0</span>

                    <button v-b-tooltip.hover title="View Details" @click="shipmentStatusmodal('HubInward',row.item)" style="background-color:white !important;
                    margin-top: -8px;
                " class="btn btn-link"  v-else>
                        <span style="color:#1b8eb7">{{row.item.hubinscan}}</span>
                    </button>
                </template>
                </b-table>
            </div>
            <b-modal size="lg" title="View Log Details" v-model="loaddetailsmodel" @ok="loaddetailsmodel=false"
            hide-footer>
            <b-row>
                <b-col sm="12" class="text-right">
                    <p > <b>Total Records :<span style="color:red;">{{loadtotalRows}}</span></b> </p>
                 </b-col>
            </b-row>
            
            <b-table
            show-empty responsive :fields="loadfields" :items="LoadDetails" :filter="filter" :busy="loadisBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :bordered="bordered"
              class="Delivery_Dashboard"
            >
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </b-table>
            </b-modal>
        </div>
    </Dispatch_date-component>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
export default {
    data() {
        return {
            selectDate : new Date(),
            items: [],
            fields: [
                { key : 'vehicleno', label : 'Vehicle No.'},
                { key: 'whname', label: 'WH Name' },
                { key: 'cms', label: 'CMS' },
                { key: 'app', label: 'APP' },
                { key: 'hubinscan', label: 'Hub In Ward' },
            ],
            totalRows : 0,
            vehicleitems : [],
            selected_vehicleno : '',
            isBusy : false,
            valueWH:[],
            fieldWH:{ text: 'name', value: 'id' },
            optionsWH:[],
            WHData:[],
            showSelectAll : true,
            LoadDetails:[],
            loadtotalRows: 0,
            loadisBusy : false,
            loaddetailsmodel : false,
            loadfields :[
                { key : 'invoiceno', label : 'Load ID'},
                { key: 'dispatch_date', label: 'Dispatch Date' },
                { key: 'mpscount', label: 'No. Of Boxes' },
                
                { key: 'destinationcompanyname', label: 'Destination Company Name' },
                { key: 'destinationpincode', label: 'Destination Pincode' },
                { key: 'warehousename', label: 'WH Name' },
                // { key: 'mpscount', label: 'MPS Count' },
               
                { key: 'lastmodifieddate', label: 'Delivery Date' },
            ],
            loadurl : '',
        }
    },
    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        console.log("userInfo",userInfo)
        this.displaydata();
        this.showWHlist();
        this.DeliveryDateList();
    },

    methods: {

        shipmentStatusmodal(status,value){
            this.loaddetailsmodel = true;
            console.log("value",value)
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            console.log("userInfo",userInfo)
            this.loadisBusy= true;
            
            var selectDate = (this.selectDate!=null)?this.formatDate(this.selectDate):"";

            let obj = {
                dispatch_date : selectDate,
                delivered_from:status,
                vehicle_id : `${value.vehicle_id}`,
                // load_id:value.load_id,
                type: 'delivery_date'
            }
            console.log("obj",obj);
            // return false
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getLoadDetailsFordeliveyDashboardDispatchDate`,obj).then(result => {
                console.log(result.body);
                this.loadisBusy = false;
                if(result.body.returnmsg === "Successful"){
               
                    this.LoadDetails  = result.body.returnvalue;
                    console.log("HHHHH",this.LoadDetails);
                    this.loadtotalRows = result.body.returnvalue.length
                    console.log("RRRRR",this.loadtotalRows);
                    
                }
                else {
                    this.LoadDetails  = [];
                    this.loadtotalRows = 0
                }
            }).catch(ex => {
                console.log('error', ex)
            })
        },

        downlaodloadurl(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            // deliveyDashboardForDispatchDateCsv?dispatch_date='2023-07-20'

            var selectDate = (this.selectDate!=null)?this.formatDate(this.selectDate):"";

            var warehouseid=(this.valueWH.length>0)? this.valueWH:"";

            this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/deliveryDashboardForDeliveryDateCsv?createddate=`+selectDate+`&&`+`vehicle_id=`+(this.selected_vehicleno!=''?this.selected_vehicleno.key: '')+`&&`+`warehouseid=`+warehouseid

            console.log("this.loadurl",this.loadurl)
        },

        displaydata: function() {

            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            this.vehicleitems=[];
            const deliveryagentobj = {
                sysusermasterid: `${userInfo.sysusermasterid}`,
                usertype: `${userInfo.user_type}`,
                isactive: "1",
                vehicle_type: "bulkreallocate",
            };
            console.log("deliveryagentobj", deliveryagentobj);
            // return false;
            this.$http
            .post(
            `${CONSTANTS.MIGRATION_API_URL}/getVehicleListing`,
            deliveryagentobj
            )
            .then((result) => {
            console.log("YYY", result);
            if (result.body.length > 0) {
                // this.isBusy = !this.isBusy
                this.data = result.body;
                // var vehicaldata = result.body;
                this.vehicleitems = result.body;
                var data = [];
    
                result.body.forEach(function (srData) {
                    data.push({
                    key:srData.vehicle_id,
                    label:srData.vehicle_no
                    });
                });
                this.vehicleitems = data;
                console.log(this.vehicleitems )
            } else {
                this.data = result.body;
                this.vehicleitems = result.body;
            }
            })
            .catch((ex) => {
            console.log("error", ex);
            });
        },

        selectsearchvehicle(value_vehicle) {
            if(value_vehicle==null){
            this.selected_vehicleno="";
            this.DeliveryDateList();
            }
            console.log("value_vehicle : ",value_vehicle);
        },

        showWHlist:function(){
          
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            
            var csvObj = {};
            console.log("JJJJJ",csvObj);
                // return false;

            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getVehicleWarehouseHubWiseList`, csvObj)
                .then(result => {
                
                if (result.body.returnmsg === 'Successful') {
                    this.optionsWH=[];
                
                    this.WHData  = result.body.returnvalue;
                    console.log("HHHHHHH",this.WHData)
                    
                    for(let j = 0; j < this.WHData.length; j++) {
                        let WH = {
                        name: this.WHData[j].warehousename + " - " + this.WHData[j].warehouseid,
                        id: this.WHData[j].warehouseid,
                        }
                    this.optionsWH.push(WH);
                    }
                
                } else {              
                    this.WHData  = result.body.returnvalue;
                }
            

            })
            .catch(ex => {
                console.log("error-----", ex);
            });
        },

        DeliveryDateList : function () {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            console.log("userInfo",userInfo)
            this.isBusy = true;
            var selectDate = (this.selectDate!=null)?this.formatDate(this.selectDate):"";

            var warehouseid=(this.valueWH.length>0)? this.valueWH:"";
            
            const obj = {
                createddate : selectDate,
                vehicle_id : (this.selected_vehicleno!=''?`${this.selected_vehicleno.key}`: ''),
                warehouseid : warehouseid,
            }
            console.log("@@@@@@",obj)
            // return false
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDeliveryDashboardList`,obj)
            .then(result =>{
                console.log("result",result)
                this.isBusy = false;
                if (result.body.returnmsg === "Successful") {
                    this.items = result.body.returnvalue;
                    console.log(this.items)
                    this.totalRows = result.body.returnvalue.length;
                } else {
                    this.items = [];
                    this.totalRows = 0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        clear(){
            this.selectDate = new Date();
            this.selected_vehicleno = '';
            this.valueWH =[];
            this.displaydata();
            this.showWHlist();
            this.DeliveryDateList();
        },

        formatDate: function(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");

        },
    },
}
</script>

<style scope>
.Delivery_Dashboard .table thead tr{
    background: #f0f3f5 !important;
    border: 1px solid #c9b9b9 !important
}
.Delivery_Dashboard .table thead tr:hover {
    background: #f0f3f5 !important;
    border: 1px solid #c9b9b9 !important
}
.Delivery_Dashboard .table thead .bordercalls th{
    border: 0px solid rgb(227, 219, 219) !important;
}
.Delivery_Dashboard .table thead tr th, .Delivery_Dashboard .table thead tr td{
    border: 1px solid rgb(221, 208, 208) !important;
}
.Delivery_Dashboard .table thead .bordercalls .totalload{
    border: 1px solid #c9b9b9 !important
}

</style>